import Vue from "vue";

import ApiService from "@/common/api.service";
import EntityService from "@/common/entity.service";

import {
	GET_ENTITY
} from "@/store/actions.type";

import {
	SET_ENTITY
} from "@/store/mutations.type";

const state = {
	entity: {}
};

const actions = {
	async [GET_ENTITY] (context, payload) {
		let location_id = payload.location_id ? payload.location_id : null;
		const data = await EntityService.getEntityByLocationId(location_id);
		context.commit(SET_ENTITY, data['data'][0]);
		return data['data'][0];
	}
};

const mutations = {
	[SET_ENTITY](state, data) {
		console.log('entity is..');
		console.log(data);
		state.entity = data;
	}
};

const getters = {
	entity (state) {
		return state.entity;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
}